import { theme } from '@/styles/theme';
import { IconProps } from '@/types/icon';

export function IconeChippu({ size, color, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="chippu"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 25"
      width={size}
      height={size + 7}
      {...props}
    >
      <g clipPath="url(#clip0_1539_37904)">
        <path
          d="M14.5687 2.52012C12.9671 0.906295 10.7974 0 8.5353 0C6.27322 0 4.10347 0.906295 2.50193 2.52012C1.70577 3.29999 1.07378 4.2343 0.643864 5.267C0.213951 6.29969 -0.00501963 7.40947 8.73139e-05 8.52976V22.3816C0.0154514 22.8387 0.205992 23.2718 0.5315 23.5897C0.857007 23.9075 1.29202 24.0852 1.74473 24.0852C2.19745 24.0852 2.63247 23.9075 2.95798 23.5897C3.28348 23.2718 3.47402 22.8387 3.48939 22.3816V15.5755C5.13475 16.7887 7.15489 17.3683 9.18584 17.21C11.2168 17.0517 13.125 16.1658 14.5667 14.7121C15.3731 13.9226 16.0107 12.9743 16.44 11.926C16.8693 10.8776 17.0811 9.75146 17.0625 8.61712C17.0816 7.4826 16.8701 6.35617 16.4412 5.30748C16.0122 4.25879 15.3749 3.31012 14.5687 2.52012ZM12.827 8.20875L8.72032 12.3676C8.49133 12.5968 8.18196 12.7255 7.85956 12.7255C7.53715 12.7255 7.22779 12.5968 6.9988 12.3676L4.55729 9.89097C4.32927 9.66035 4.20128 9.34767 4.20147 9.02172C4.20156 8.86032 4.23312 8.70052 4.29435 8.55145C4.35557 8.40237 4.44526 8.26694 4.5583 8.15288C4.67134 8.03883 4.8055 7.94838 4.95314 7.8867C5.10078 7.82503 5.259 7.79333 5.41877 7.79342C5.74143 7.79361 6.05079 7.92328 6.27882 8.1539L7.85956 9.75078L11.1055 6.47575C11.3335 6.24513 11.6429 6.11547 11.9656 6.11528C12.2882 6.11509 12.5977 6.24439 12.826 6.47474C13.0543 6.70509 13.1827 7.01761 13.1829 7.34357C13.183 7.66952 13.0551 7.9822 12.827 8.21282V8.20875Z"
          fill={color ?? theme.colors.accent.accent[9]}
        />
      </g>
      <defs>
        <clipPath id="clip0_1539_37904">
          <rect width="17.0636" height="24.0852" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
